import React from 'react';
import decodeToken from '../../../../utils/decode-token';
import PersonalSettings from './personal-settings';
import PmaSettingsContent from './pma-settings-content';
import HacSettingsContent from './hac-settings-content';
import SettingsPage from './settings-page';

const PERSONAL_SETTINGS_VARIANT_BY_ROLE = {
  admin: 'admin',
  marketAdmin: 'admin',
  countryAdmin: 'admin',
  shippingAdmin: 'shippingAdmin',
  retailer: 'retailer',
  retailerGM: 'retailer',
  translator: 'translator',
  reviewer: 'translator',
};

const AccountSettings = () => {
  const token = sessionStorage.getItem('token');
  const role = token ? decodeToken(token)?.role : null;

  if (role === 'pma' || role === 'pmaGM') return <PmaSettingsContent />;
  if (role === 'hac') return <HacSettingsContent />;

  const variant = PERSONAL_SETTINGS_VARIANT_BY_ROLE[role];
  if (variant) return <PersonalSettings variant={variant} />;

  return <SettingsPage allowed={role === 'superAdmin'} />;
};

export default AccountSettings;
